module.exports = __webpack_public_path__ + "img/feeling.3a35c3d3.svg";